import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalFooter, Row } from 'react-bootstrap'
import useUserStore from '../../stores/UserStore'
import axios from '../../../../libs/axios'
import UserForm from '../Form/Form'
import { setFormError , resetStore } from '../libs/include'
import DisplayMessage from '../../../../components/DisplayMessage'

function EditUserModal({id}) {
  const apiUrl =  process.env.REACT_APP_BACKEND_URL
  const user = useUserStore()
  const [show, setShow] = useState(false)
  const [error, setError] = useState(false)
  const [component, setComponent] = useState(false)
  const [isLoading, setIsloading] = useState(false)
  const [message, setMessage] = useState(false)

  const handleClose = () => {
    setShow(false)
    setError(false)
    resetStore()
    //console.log('store reset')
  }
  
  function handleEditClick({id}){
    setShow(true)
    fetchData(id)
    //console.log('fetch data for ' + id)
  }

  function handleSaveClick({id}){
    //console.log(id)
    sendData()
  }

  function fetchData(id){
    setIsloading(true)
    const store = useUserStore.getState()
    axios({
      //url: `${store.show_url}/${id}`,
      url: `${apiUrl}/admin/users/${id}`,
    })
    .then( response =>{
      //console.log(response)
  
      useUserStore.setState({

                  is_approved: {
                          value: response.data?.user?.is_approved
                        },

                  email_verified_at: {
                          value: response.data?.user?.email_verified_at
                        },

                  role:{
                          value: response.data?.user?.role
                        },
                  email:{
                          value: response.data?.user?.email
                        },
                  // name: {
                  //         value: response.data?.user?.profile?.name
                  //       },
                  name: {
                          value: response.data?.user?.name
                        },
            occupation: {
                          value: response.data?.user?.profile?.occupation
                        },
                  nric: {
                          value: response.data?.user?.nric
                        },
                phone: {
                          value: response.data?.user?.profile?.phone
                        },
              level:  {
                          value: response.data?.user?.profile?.level
                        },
              building:  {
                          value: response.data?.user?.profile?.building
                        },
              address:  {
                          value: response.data?.user?.profile?.address
                        },
        user_department_id: {
                          value: response.data?.user?.profile?.user_department_id
                        },
      })

      //now assign the Form
      setComponent(<UserForm />)
      setIsloading(false)
    })
    .catch ( error => {
      console.warn(error)
    })
  }

  function sendData() {
    setMessage(null)
      const fieldNames = [

                  'role',
                  'email',
                  'email_verified_at',
                  'password',
                  'name',
                  'occupation',
                  'nric',
                  'phone',
                  'level',
                  'building',
                  'address',
                  'user_department_id',
                  'is_approved'
                ];

      const formData = new FormData();
      formData.append('_method', 'put')
  

      // create payload
      fieldNames.forEach((fieldName) => {
        const value = user?.[fieldName]?.value;
        // email_verified_at must be sent even when null (to unverify)
        if (fieldName === 'email_verified_at') {
          formData.append(fieldName, value ?? '');
        } else if (value !== null && value !== '' && value !== undefined) {
          formData.append(fieldName, value);
        }
      });

      axios({
          //url: `${user.update_url}/${id}`,  // user update API
          url: `${apiUrl}/admin/users/${id}`,
          method: 'post', // method is POST
          data: formData, // payload is formData
      })
      .then( response => {
          //console.log(response.data)
     
          useUserStore.setState({ refresh: true }) // useEffect trigger
          handleClose() // close modal

          setMessage(response.data.message)
      })
      .catch( error => {
        if (error.response && error.response.status === 422) {
          // Handle status code 422 errors here
          console.warn(error.response.data.errors)
          handleValidationErrors(fieldNames, error.response.data.errors, setFormError);
          setError(true)
        } else {
          // Handle other errors (e.g., network issues, server errors)
          console.error(error);
          
          setError(true)
        }
      })
  };



  return (
    <>
      { message && <DisplayMessage variant='success' message={message} />}
      
      <Button size={'sm'} onClick={ () => handleEditClick({id}) }>Kemaskini</Button>

      <Modal show={show} onHide={handleClose} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Kemaskini Pengguna</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <UserForm /> */}
          { isLoading ?  'loading...' : component }
        </Modal.Body>
        <ModalFooter>
        <Row className='text-danger'>
            { error &&
            <>
            Sila lihat kesemua tabs untuk ralat
            </>}
          </Row>
          <Button variant="secondary" onClick={handleClose}>
            Tutup
          </Button>
          <Button variant="primary" onClick={ () => handleSaveClick({id})}>
            Kemaskini
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default EditUserModal;

function handleValidationErrors(fieldNames, validationErrors, setFormError) {
  //const fieldNames = ['name', 'email', 'nric', 'password'];

  fieldNames.forEach((fieldName) => {
    if (validationErrors[fieldName]) {
      setFormError(fieldName, ` ${validationErrors[fieldName]}`);
    }
  });
}
